<template>
    <div class="mt-15">
        <div v-if="bloqueo==0">
            <v-row>
                <v-col cols="12" class="mt-10 text-center">
                    <img src="@/assets/denegado.png" />
                </v-col>
            </v-row>
        </div>
        <div v-else-if="bloqueo==1">
        <v-container>
            <v-row class="mt-7">
                <v-col cols="12" md="3" class="mt-n7"></v-col>
                <v-col cols="12" md="6" class="mt-n7 d-flex">
                    <v-text-field class='text-body-2' v-model="servicio" label="Servicio" outlined dense rounded></v-text-field>
                    <v-btn @click="save_service()" class="ml-2 mt-1" small color="teal" dark rounded><v-icon small>search</v-icon></v-btn>
                </v-col>
                <v-col cols="12" md="6" class="mt-n7"></v-col>
            </v-row>
            <v-row class="mt-5">
                <v-col cols="12" md="3" class="mt-n7"></v-col>
                <v-col cols="12" md="6" class="mt-n7">
                    <v-simple-table fixed-header dense height="400" style="border:1px solid lightgrey">
                        <thead>
                            <tr>
                                <th style="background-color: lightgrey;" class="text-center">&nbsp;</th>
                                <th style="background-color: lightgrey;">Servicio</th>
                                <!-- <th style="background-color: lightgrey;">Detalle</th> -->
                                <!-- <th style="background-color: lightgrey;" class="text-center">&nbsp;</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in services" :key="item.ID">
                                <td class="text-center">                                        
                                    <v-icon @click="delete_service(item)" small color="red">delete</v-icon>
                                </td>
                                <td><span class="text-button">{{ item.Descripcion }}</span></td>
                                <!-- <td>
                                    <v-chip class="ml-5">
                                        <span class="text-button">{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.content)) }}</span>
                                    </v-chip>
                                </td> -->
                                <!-- <td @click="handleUser(item)" class="d-flex">                                    
                                    <v-btn icon><v-icon large>navigate_next</v-icon></v-btn>
                                </td> -->
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col cols="12" md="3" class="mt-n7"></v-col>
            </v-row>
        </v-container>
    </div>
        <div style="height: 50px;"></div>
        <v-footer fixed color="#c1680e" height="50"></v-footer>

        <!-- dialog detalle --> 
        <v-dialog v-model="d_detail" transition="dialog-bottom-transition" max-width="600" persistent>
        <v-card>
            <v-card-title>
                {{ txt_service.toUpperCase() }}
                <v-spacer></v-spacer>
                <v-icon @click="d_detail=false">close</v-icon>
            </v-card-title>
            <v-card-text>
                <v-row class="mt-7">
                    <v-col cols="12" md="6" class="mt-n7">
                        <v-text-field class='text-body-2' v-model="detalle" label="Detalle" outlined dense rounded></v-text-field>
                    </v-col>
                    <v-col cols="8" md="4" class="mt-n7">
                        <v-text-field type="number" class='text-body-2' v-model="valor2" label="Valor" outlined dense rounded></v-text-field>
                    </v-col>
                    <v-col cols="4" md="2" class="mt-n7">
                        <v-btn @click="save_detalle()" class="mt-1" small color="teal" dark rounded><v-icon small>search</v-icon></v-btn>                        
                    </v-col>
                </v-row>
                <v-row class="mt-n7">
                    <v-col cols="12" md="12">
                        <v-simple-table fixed-header dense height="300">
                            <thead>
                                <tr>
                                    <th style="background-color: lightgrey;">Detalle</th>
                                    <th style="background-color: lightgrey;" class="text-end">Valor</th>
                                    <th style="background-color: lightgrey;" class="text-center">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in myservices" :key="item.ID">
                                    <td><span class="text-body-2">{{ item.Descripcion }}</span></td>
                                    <td class="text-end"><span class="text-body-2">{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Costo)) }}</span></td>
                                    <td class="text-center"><v-icon @click="delete_detalle(item)" small color="red">delete</v-icon></td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        </v-dialog>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>

            </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
form img{
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 6px solid #AAA;
}
form div:first-child{
  align-items: center;
}
form div:first-child input{
  display: none;
}
form div:first-child label{
  background: #1F5F74;
  color: white;
  padding: 6px 20px;
  cursor: pointer;
  border-radius: 3px;
}
form input{
  padding: 8px 20px;
  border: 1px solid #AAA;
  border-radius: 3px;
}
</style>
<script>
import axios from "axios";
export default {
  name: 'Usuarios',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,
    snack:false,
    color_snack:'',
    mensaje:'',
    bloqueo:null,
    loading:false,

    services:[],
    detailservice:[],
    myservices:[],
    d_services:false,
    id_service:0,
    txt_service:'',
    d_detail:false,

    servicio:'',
    valor1:0,
    detalle:'',
    valor2:'',

  }),
  async mounted(){
    const myToken = localStorage.getItem('mytoken');
    const myUser = localStorage.getItem('myuser');
    const myContrato = localStorage.getItem('mycontrato');
    const myTime = localStorage.getItem('timeuser');
    if(myToken!=null && myUser!=null && myContrato!=null){
      //verificamos la expiracion
      const ahora = new Date();
      const expira = new Date(myTime);
      if(ahora > expira){
        this.goLogin()
      } else {
        this.apikey = myToken;
        this.contrato = myContrato;
        this.user = myUser;
        this.loading=true;
        this.bloqueo = await this.myPermiso(7);
        if(parseInt(this.bloqueo)!=0){
            await this.searchServicios();
            await this.searchDetailService();
            await this.cuenta_detalle();
        };
        this.loading=false
      }
    } else {
        this.goLogin();
    }
  },
  methods:{
    async cuenta_detalle(){
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.apikey
            };
            if(this.services.length!=0){
                for (let index = 0; index < this.services.length; index++) {
                    const element = this.services[index];
                    const identity = element.ID;
                    const filter = this.detailservice.filter(res => parseInt(res.Id_Servicio)==parseInt(identity));
                    const count = filter.length;
                    element.content = count;
                }
            }
        } catch (error) {
          console.log(error)  
        }
    },
    async searchServicios(){
        let temp_array = [];
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.apikey
            };
            const params = {
                'contrato' : this.contrato,
                'user' : this.user,
                'id' : 'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/services/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                console.log('Services', datos);
                datos.forEach(element => {
                    temp_array.push({
                        'ID': element.ID,
                        'Descripcion': element.Descripcion,
                        'Costo': element.Costo,
                        'content': 0
                    })
                });
                this.services = temp_array;
            }
        } catch (error) {
            console.log(error)
        }
    },
    async handleUser(line){
        const filter = this.detailservice.filter(res => parseInt(res.Id_Servicio)==parseInt(line.ID));
        this.myservices = filter;
        this.id_service = line.ID;
        this.txt_service = line.Descripcion;
        this.d_detail=true;
    },
    async searchDetailService(){
        let temp_array = [];
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.apikey
            };
            const params = {
                'contrato' : this.contrato,
                'user' : this.user,
                'id' : 'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/detail/services/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                console.log('Detail', datos);
                datos.forEach(element => {
                    temp_array.push({
                        'ID': element.ID,
                        'Id_Servicio': element.Id_Servicio,
                        'Descripcion': element.Descripcion,
                        'Costo': element.Costo
                    })                    
                });
                this.detailservice = temp_array;
            }
        } catch (error) {
            console.log(error)
        };
    },
    goLogin(){
      localStorage.removeItem('mytoken');
      localStorage.removeItem('myuser');
      localStorage.removeItem('mycontrato');
      localStorage.removeItem('timeuser');
      this.$router.push({name:'Login'})
    },
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.apikey
            };
            const params = {
                'contrato' : this.contrato,
                'user' : this.user,
                'id' : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    clsInput(){
        this.servicio='';
        this.valor1=0;
        this.detalle='';
        this.valor2=0;
        this.myservices=[];
    },
    async save_service(){
        this.loading=true;
        this.servicio = '' + this.servicio;
        if(this.servicio!=null && this.servicio!=''){
            this.servicio = this.servicio.toUpperCase();
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params ={
                    contrato : this.contrato,
                    user: this.user,
                    detalle: this.servicio,
                    valor: this.valor1
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/service/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    await this.searchServicios();
                    await this.cuenta_detalle();
                    this.servicio='';
                    this.valor1=0;
                }            
            } catch (error) {
                console.log(error)
            }   
        } else {
            this.color_snack='error';
            this.mensaje='Ingrese servicio';
            this.snack=true
        }
        this.loading=false;
    },
    async delete_service(line){
        this.loading=true;
        if(parseInt(line.content)==0){
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params ={
                    contrato : this.contrato,
                    user: this.user,
                    id_servicio: line.ID,
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/delete/service/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    await this.searchServicios();
                    await this.cuenta_detalle();
                    this.servicio='';
                    this.valor1=0;
                }            
            } catch (error) {
                console.log(error)
            }
        } else {
            this.color_snack='error';
            this.mensaje='Existe detalle en el servicio que deseas eliminar';
            this.snack=true
        }
        this.loading=false;
    },
    async save_detalle(){
        this.loading=true;
        this.detalle = '' + this.detalle;
        if(this.detalle!=null && this.detalle!=''){
            this.detalle = this.detalle.toUpperCase();
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params ={
                    contrato : this.contrato,
                    user: this.user,
                    id_servicio:this.id_service,
                    detalle: this.detalle,
                    valor: this.valor2
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/detail/service/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    await this.searchDetailService();
                    await this.cuenta_detalle();
                    const filter = this.detailservice.filter(res => parseInt(res.Id_Servicio)==parseInt(this.id_service));
                    this.myservices = filter;
                    this.detalle='';
                    this.valor2='';
                }            
            } catch (error) {
                console.log(error)
            };
        } else {
            this.color_snack='error';
            this.mensaje='Ingrese detalle del servicio';
            this.snack=true
        }
        this.loading=false;
    },
    async delete_detalle(line){
        this.loading=true;        
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params ={
                contrato : this.contrato,
                user: this.user,
                id_detalle: line.ID,
                id_servicio: line.Id_Servicio ,
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/delete/detail/service/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                await this.searchDetailService()
                await this.cuenta_detalle();
                const filter = this.detailservice.filter(res => parseInt(res.Id_Servicio)==parseInt(this.id_service));
                this.myservices = filter;
                this.detalle='';
                this.valor2='';
            }
        } catch (error) {
            console.log(error)
        };
        this.loading=false;
    }

  }
}
</script>
